import { Link } from 'react-router-dom';
import { ArrowLeft, Eye, SlidersHorizontal } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import { cn } from '@/shared/lib/cn';

interface AdminInspectHeaderMarkProps {
  storeName: string;
  /** Contraste sobre backgroundColor do passbook (header tintado). */
  onBrandColors?: boolean;
  className?: string;
}

/** Chip compacto de inspeção — fica à direita do logo no header do cliente. */
export function AdminInspectHeaderMark({ storeName, onBrandColors = false, className }: AdminInspectHeaderMarkProps) {
  return (
    <span
      className={cn(
        'inline-flex max-w-[min(100%,280px)] items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        onBrandColors
          ? 'bg-black/15 text-inherit ring-1 ring-inset ring-black/10'
          : 'bg-primary/15 text-primary ring-1 ring-inset ring-primary/25',
        className,
      )}
      title={`Modo inspeção — ${storeName}`}
    >
      <Eye className="size-3.5 shrink-0 opacity-90" aria-hidden />
      <span className="truncate">
        Modo inspeção
        <span className="hidden sm:inline"> — {storeName}</span>
      </span>
    </span>
  );
}

const brandButton = 'bg-black/10 text-inherit hover:bg-black/20 border-0 shadow-none';

/** Vai para a lista de clientes. A inspeção continua: só deslogar ou abrir outra loja a troca. */
export function AdminInspectBackButton({ onBrandColors = false }: { onBrandColors?: boolean }) {
  return (
    <Button variant="secondary" size="sm" className={cn('shrink-0', onBrandColors && brandButton)} asChild>
      <Link to="/clientes?view=grid">
        <ArrowLeft className="size-4" />
        <span className="hidden sm:inline">Clientes</span>
      </Link>
    </Button>
  );
}

/** Abre o hub do cliente desta loja (recursos, páginas, usuários, IA). Só o master. */
export function AdminInspectConfigureButton({ idPassbook, onBrandColors = false }: { idPassbook: string; onBrandColors?: boolean }) {
  return (
    <Button variant="secondary" size="sm" className={cn('shrink-0', onBrandColors && brandButton)} asChild>
      <Link to={`/loja/${idPassbook}/configurar`}>
        <SlidersHorizontal className="size-4" />
        <span className="hidden sm:inline">Configurar</span>
      </Link>
    </Button>
  );
}
